// removed by extract-text-webpack-plugin
module.exports = {"base":"Stub_base--3ve8_","isDemo":"Stub_isDemo--1O0FH","close":"Stub_close--1k22k","holder":"Stub_holder--1LgzA","title":"Stub_title--ckqrj","message":"Stub_message--3yStF"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-mt-bootstrap/lib/components/Stub/Stub.css
// module id = 1839
// module chunks = 16